import { render, staticRenderFns } from "./PostByIdFilter.vue?vue&type=template&id=dd10af12&"
import script from "./PostByIdFilter.vue?vue&type=script&lang=js&"
export * from "./PostByIdFilter.vue?vue&type=script&lang=js&"
import style0 from "./PostByIdFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
installComponents(component, {VCombobox})
